import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { crudSaga, querySaga } from '../../../utils/reduxHelper';

function* resetSiteGroupSaga() {
    yield put(appActions.SITEGROUP_RESET_SUCCESS());
}

function* watchSiteGroupUpdateRequest() {
    yield takeLatest(
        appActions.SITEGROUP_UPDATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/sitegroup/update',
                appActions.SITEGROUP_UPDATE_SUCCESS,
                appActions.SITEGROUP_UPDATE_FAILURE,
                'PUT',
            );
        },
    );
}

function* watchSiteGroupCreateRequest() {
    yield takeLatest(
        appActions.SITEGROUP_CREATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/sitegroup/save',
                appActions.SITEGROUP_CREATE_SUCCESS,
                appActions.SITEGROUP_CREATE_FAILURE,
                'POST',
            );
        },
    );
}

function* watchSiteGroupDeleteRequest() {
    yield takeLatest(
        appActions.SITEGROUP_DELETE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                `/communication/v1/sitegroup`,
                appActions.SITEGROUP_DELETE_SUCCESS,
                appActions.SITEGROUP_DELETE_FAILURE,
                'DELETE',
            );
        },
    );
}

function* watchSiteGroupGetAllRequest() {
    yield takeLatest(
        appActions.SITEGROUP_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/sitegroup',
                appActions.SITEGROUP_GET_ALL_SUCCESS,
                appActions.SITEGROUP_GET_ALL_FAILURE,
            );
        },
    );
}

export default function* siteGroupWatcher() {
    yield* watchSiteGroupUpdateRequest();
    yield* watchSiteGroupCreateRequest();
    yield* watchSiteGroupGetAllRequest();
    yield* watchSiteGroupDeleteRequest();
    yield takeLatest(
        appActions.SITEGROUP_RESET_REQUEST.type,
        resetSiteGroupSaga,
    );
    // Add other watchers here
}
